var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_PRODUCTS = 'api/product';
export const bulkImport = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}`, 'Content-Type': false }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_PRODUCTS}/${storeId}/bulk`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error importing products workbook:', error);
            throw error;
        }
    });
};
/**
 * @deprecated Use `products.bulkImport` for the canonical XLSX Product Bulk import.
 */
export const bulkUpdate = function (storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return bulkImport.call(this, storeId, data);
    });
};
export const updateById = function (id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.put(`${GET_SET_PRODUCTS}/${id}`, data, config);
        }
        catch (error) {
            console.error('Error fetching updateById:', error);
            throw error;
        }
    });
};
// New: update product price option
export const updatePriceOption = function (productId, optionId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.put(`${GET_SET_PRODUCTS}/${productId}/price-options/${optionId}`, data, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error updating price option:', error);
            throw error;
        }
    });
};
